// import { FC, useState, useEffect } from 'react'
// import { useFormik } from 'formik'
// import * as Yup from 'yup'
// import { getUserById } from '../core/_requests'
// import { unitListItem, currencyList } from '../../../../../../_metronic/helpers'
// import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
// import { useQueryResponse } from '../core/QueryResponseProvider'
// import { useListView } from '../core/ListViewProvider'

// // type Props = {
// //     isUserLoading: boolean
// //     user?: any
// // }
// type Props = {
//     isUserLoading: boolean
//     structureId?: string
//     tableData?: any[]
//     onClose?: () => void
//     user?: any  // Keep this if it was there before, or remove if not needed
//   }

// const editUserSchema = Yup.object().shape({
//     priceData: Yup.array().of(
//         Yup.object().shape({
//             price: Yup.number().required('Price is required'),
//             unit: Yup.string().required('Unit is required'),
//             currency: Yup.string().required('Currency is required'),
//         })
//     ),
// })

// const PriceTemplateEditForm: FC<Props> = ({ user = {}, isUserLoading }) => {
//     const [priceData, setPriceData] = useState<any[]>([])
//     const [data, setData] = useState<any[]>([])
//     const { setItemIdForUpdate } = useListView()
//     const { refetch } = useQueryResponse()

//     useEffect(() => {
//         const fetchCategories = async () => {
//             try {
//                 const res: any = await getUserById('clients/101212/categories')
//                 const resData = res
//                 setData(resData)
//             } catch (error) {
//                 console.error('Error fetching categories', error)
//             }
//         }
//         fetchCategories()
//     }, [])

//     useEffect(() => {
//         if (data && data.length) {
//             const dropdownData = data.map((eachData) => ({
//                 label: eachData.name,
//                 value: eachData.id,
//             }))
//             fetchPriceData(dropdownData)
//         }
//     }, [data])

//     const fetchPriceData = async (dropdownData: any[]) => {
//         try {
//             const promises = dropdownData.map(async (category) => {
//                 if (!category.value) return []

//                 const res: any = await getUserById(`categories/${category.value}/price/templateId=`)
//                 const resData = res

//                 return resData.map((item: any) => ({
//                     price: item.price,
//                     currency: item.currency,
//                     categoryId: item.categoryId,
//                     itemId: item.itemId,
//                     unit: item.unit,
//                     category: category.label,
//                     item: item.itemName,
//                     structureId: '',
//                     structureName: '',
//                 }))
//             })

//             const allResults = await Promise.all(promises)
//             const mergedResults = allResults.flat()

//             setPriceData(mergedResults)
//         } catch (error) {
//             console.error('Error fetching price data', error)
//         }
//     }

//     const cancel = (withRefresh?: boolean) => {
//         if (withRefresh) {
//             refetch()
//         }
//         setItemIdForUpdate(undefined)
//     }

//     // Function to get auth token from local storage
//     const getAuthToken = () => {
//         try {
//             const authData = localStorage.getItem('kt-auth-react-v');
//             if (authData) {
//                 const parsedData = JSON.parse(authData);
//                 // Extract token from the parsed data
//                 if (parsedData && parsedData.data && parsedData.data.token) {
//                     return parsedData.data.token;
//                 }
//             }
//             return null;
//         } catch (error) {
//             console.error('Error getting auth token from local storage', error);
//             return null;
//         }
//     };

//     const formik = useFormik({
//         initialValues: {
//             priceData: priceData,
//         },
//         enableReinitialize: true,
//         validationSchema: editUserSchema,
//         onSubmit: async (values, { setSubmitting }) => {
//             console.log("Form submission started");
//             console.log("Form values:", values);

//             // Check if priceData is empty
//             if (!values.priceData || values.priceData.length === 0) {
//                 console.error("No price data to submit");
//                 errorToast("No price data to submit");
//                 setSubmitting(false);
//                 return;
//             }

//             // Get token from local storage
//             const token = getAuthToken();
//             if (!token) {
//                 console.error("Authentication token not found");
//                 errorToast("Authentication token not found");
//                 setSubmitting(false);
//                 return;
//             }

//             setSubmitting(true);
//             try {
//                 console.log("Preparing data for API call");

//                 // Use all items in the payload
//                 const updatedPriceData = values.priceData.map((item) => ({
//                     ...item,
//                     // We're keeping structureId and structureName empty since we don't need template name
//                     structureId: '',
//                     structureName: '',
//                 }));

//                 console.log("API payload:", updatedPriceData);

//                 // Direct fetch to the specified API endpoint with auth token
//                 console.log("Making API call with authentication...");
//                 const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}bulkPrice/update`, {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${token}`, // Add the token to the Authorization header
//                     },
//                     body: JSON.stringify(updatedPriceData),
//                 });

//                 console.log("API response status:", response.status);

//                 if (!response.ok) {
//                     const errorText = await response.text();
//                     console.error("Error response:", errorText);
//                     throw new Error(`API error: ${response.status} - ${errorText}`);
//                 }

//                 const responseData = await response.json();
//                 console.log("API response data:", responseData);

//                 successToast('Updated Successfully');
//                 console.log("Attempting to close modal...");
//                 cancel(true);
//             } catch (ex: any) {
//                 console.error("API call error:", ex);
//                 errorToast(ex.message || 'Something Went Wrong');
//             } finally {
//                 setSubmitting(false);
//                 console.log("Form submission completed");
//             }
//         },
//     });

//     const handleInputChange = (index: number, field: string, value: any) => {
//         const updated = [...formik.values.priceData];
//         updated[index][field] = value;
//         formik.setFieldValue('priceData', updated);
//     };

//     return (
//         <div>
//             <h2>Category price table</h2>

//             <form onSubmit={(e) => {
//                 console.log("Form submit event triggered");
//                 formik.handleSubmit(e);
//             }}>
//                 <table style={{ borderCollapse: 'collapse', width: '100%' }} cellPadding={10} cellSpacing={0}>
//                     <thead>
//                         <tr>
//                             <th style={{ border: '1px solid #ccc', padding: '8px' }}>Category</th>
//                             <th style={{ border: '1px solid #ccc', padding: '8px' }}>Item</th>
//                             <th style={{ border: '1px solid #ccc', padding: '8px' }}>Unit</th>
//                             <th style={{ border: '1px solid #ccc', padding: '8px' }}>Price</th>
//                             <th style={{ border: '1px solid #ccc', padding: '8px' }}>Currency</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {formik.values.priceData.length > 0 ? (
//                             formik.values.priceData.map((row, index) => (
//                                 <tr key={index}>
//                                     <td style={{ border: '1px solid #ccc', padding: '8px' }}>{row.category}</td>
//                                     <td style={{ border: '1px solid #ccc', padding: '8px' }}>{row.item}</td>
//                                     <td style={{ border: '1px solid #ccc', padding: '8px' }}>
//                                         <select
//                                             value={row.unit}
//                                             onChange={(e) => handleInputChange(index, 'unit', e.target.value)}
//                                         >
//                                             <option value=''>Select Unit</option>
//                                             {unitListItem.map((unit: any, idx: number) => (
//                                                 <option key={idx} value={unit.value}>
//                                                     {unit.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </td>
//                                     <td style={{ border: '1px solid #ccc', padding: '8px' }}>
//                                         <input
//                                             type='number'
//                                             value={row.price}
//                                             onChange={(e) => handleInputChange(index, 'price', e.target.value)}
//                                             style={{ width: '100px' }}
//                                         />
//                                     </td>
//                                     <td style={{ border: '1px solid #ccc', padding: '8px' }}>
//                                         <select
//                                             value={row.currency}
//                                             onChange={(e) => handleInputChange(index, 'currency', e.target.value)}
//                                         >
//                                             <option value=''>Select Currency</option>
//                                             {currencyList.map((currency: any, idx: number) => (
//                                                 <option key={idx} value={currency.value}>
//                                                     {currency.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td
//                                     colSpan={5}
//                                     style={{ textAlign: 'center', border: '1px solid #ccc', padding: '8px' }}
//                                 >
//                                     No Data Found
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//                 <div style={{ marginTop: '20px' }}>
//                     <button
//                         type='submit'
//                         disabled={formik.isSubmitting}
//                         style={{
//                             padding: '8px 16px',
//                             backgroundColor: '#1e88e5',
//                             color: 'white',
//                             border: 'none',
//                             borderRadius: '4px',
//                             cursor: 'pointer'
//                         }}
//                     >
//                         {formik.isSubmitting ? 'Saving...' : 'Save changes'}
//                     </button>
//                     <button
//                         type='button'
//                         onClick={() => cancel()}
//                         style={{
//                             marginLeft: '10px',
//                             padding: '8px 16px',
//                             backgroundColor: '#e0e0e0',
//                             border: 'none',
//                             borderRadius: '4px',
//                             cursor: 'pointer'
//                         }}
//                     >
//                         Cancel
//                     </button>
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default PriceTemplateEditForm;










import { FC, useState, useEffect } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { getUserById } from '../core/_requests'
import { unitListItem, currencyList } from '../../../../../../_metronic/helpers'
import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useListView } from '../core/ListViewProvider'

// type Props = {
//     isUserLoading: boolean
//     user?: any
// }
type Props = {
    isUserLoading: boolean
    structureId?: string
    structureName?: string
    tableData?: any[]
    onClose?: () => void
    user?: any  // Keep this if it was there before, or remove if not needed
}

const editUserSchema = Yup.object().shape({
    priceData: Yup.array().of(
        Yup.object().shape({
            price: Yup.number().required('Price is required'),
            unit: Yup.string().required('Unit is required'),
            currency: Yup.string().required('Currency is required'),
        })
    ),
})

const PriceTemplateEditForm: FC<Props> = ({
    user = {},
    isUserLoading,
    structureId,
    structureName,
    tableData = [],
    onClose
}) => {
    const [priceData, setPriceData] = useState<any[]>([])
    const [data, setData] = useState<any[]>([])
    const { setItemIdForUpdate } = useListView()
    const { refetch } = useQueryResponse()

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res: any = await getUserById('clients/101212/categories')
                const resData = res
                setData(resData)
            } catch (error) {
                console.error('Error fetching categories', error)
            }
        }
        fetchCategories()
    }, [])

    // useEffect(() => {
    //     if (data && data.length) {
    //         const dropdownData = data.map((eachData) => ({
    //             label: eachData.name,
    //             value: eachData.id,
    //         }))
    //         fetchPriceData(dropdownData)
    //     }
    // }, [data])

    // const fetchPriceData = async (dropdownData: any[]) => {
    //     try {
    //         const promises = dropdownData.map(async (category) => {
    //             if (!category.value) return []

    //             const res: any = await getUserById(`categories/${category.value}/price/templateId=`)
    //             const resData = res

    //             return resData.map((item: any) => ({
    //                 price: item.price,
    //                 currency: item.currency,
    //                 categoryId: item.categoryId,
    //                 itemId: item.itemId,
    //                 unit: item.unit,
    //                 category: category.label,
    //                 item: item.itemName,
    //                 structureId: '',
    //                 structureName: '',
    //             }))
    //         })

    //         const allResults = await Promise.all(promises)
    //         const mergedResults = allResults.flat()

    //         setPriceData(mergedResults)
    //     } catch (error) {
    //         console.error('Error fetching price data', error)
    //     }
    // }




    useEffect(() => {
        if (tableData && tableData.length > 0) {
            // Transform tableData to match the expected format
            const transformedData = tableData.map((item) => ({
                price: item.price || '',
                currency: item.currency || '',
                categoryId: item.category || '',
                itemId: item.itemId || '',
                unit: item.unit || '',
                category: item.categoryName || '',
                item: item.itemName || '',
                structureId: structureId || '',
                // structureName: '',
                structureName: structureName || '', // Use the passed structureName prop
            }))
            setPriceData(transformedData)
        }
    }, [tableData, structureId, structureName])




    // const cancel = (withRefresh?: boolean) => {
    //     if (withRefresh) {
    //         refetch()
    //     }
    //     setItemIdForUpdate(undefined)
    // }


    const cancel = (withRefresh?: boolean) => {
        if (withRefresh) {
            refetch()
        }
        setItemIdForUpdate(undefined)
        if (onClose) {
            onClose() // Close the modal
        }
    }
    //     const cancel = (withRefresh?: boolean) => {
    //     if (withRefresh) {
    //         refetch()
    //     }
    //     setItemIdForUpdate(undefined)
    //     if (onClose) {
    //         onClose() // Close the modal
    //     }
    // }

    // Function to get auth token from local storage
    const getAuthToken = () => {
        try {
            const authData = localStorage.getItem('kt-auth-react-v');
            if (authData) {
                const parsedData = JSON.parse(authData);
                // Extract token from the parsed data
                if (parsedData && parsedData.data && parsedData.data.token) {
                    return parsedData.data.token;
                }
            }
            return null;
        } catch (error) {
            console.error('Error getting auth token from local storage', error);
            return null;
        }
    };

    const formik = useFormik({
        initialValues: {
            priceData: priceData,
        },
        enableReinitialize: true,
        validationSchema: editUserSchema,
        onSubmit: async (values, { setSubmitting }) => {
            console.log("Form submission started");
            console.log("Form values:", values);

            // Check if priceData is empty
            if (!values.priceData || values.priceData.length === 0) {
                console.error("No price data to submit");
                errorToast("No price data to submit");
                setSubmitting(false);
                return;
            }

            // Get token from local storage
            const token = getAuthToken();
            if (!token) {
                console.error("Authentication token not found");
                errorToast("Authentication token not found");
                setSubmitting(false);
                return;
            }

            setSubmitting(true);
            try {
                console.log("Preparing data for API call");

                // Use all items in the payload
                const updatedPriceData = values.priceData.map((item) => ({
                    ...item,
                    // We're keeping structureId and structureName empty since we don't need template name
                    structureId: item.structureId || structureId || '',
                    structureName: item.structureName
                }));

                console.log("API payload:", updatedPriceData);

                // Direct fetch to the specified API endpoint with auth token
                console.log("Making API call with authentication...");
                const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}bulkPrice/update`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`, // Add the token to the Authorization header
                    },
                    body: JSON.stringify(updatedPriceData),
                });

                console.log("API response status:", response.status);

                if (!response.ok) {
                    const errorText = await response.text();
                    console.error("Error response:", errorText);
                    throw new Error(`API error: ${response.status} - ${errorText}`);
                }

                const responseData = await response.json();
                console.log("API response data:", responseData);

                successToast('Updated Successfully');
                console.log("Attempting to close modal...");
                cancel(true);
            } catch (ex: any) {
                console.error("API call error:", ex);
                errorToast(ex.message || 'Something Went Wrong');
            } finally {
                setSubmitting(false);
                console.log("Form submission completed");
            }
        },
    });

    const handleInputChange = (index: number, field: string, value: any) => {
        const updated = [...formik.values.priceData];
        updated[index][field] = value;
        formik.setFieldValue('priceData', updated);
    };

    return (
        <div>
            <h2>Category price table</h2>

            <div>
                <table style={{ borderCollapse: 'collapse', width: '100%' }} cellPadding={10} cellSpacing={0}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Category</th>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Item</th>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Unit</th>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Price</th>
                            <th style={{ border: '1px solid #ccc', padding: '8px' }}>Currency</th>
                        </tr>
                    </thead>
                    <tbody>
                        {formik.values.priceData.length > 0 ? (
                            formik.values.priceData.map((row, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>{row.category}</td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>{row.item}</td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                                        <select
                                            value={row.unit}
                                            onChange={(e) => handleInputChange(index, 'unit', e.target.value)}
                                        >
                                            <option value=''>Select Unit</option>
                                            {unitListItem.map((unit: any, idx: number) => (
                                                <option key={idx} value={unit.value}>
                                                    {unit.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                                        <input
                                            type='number'
                                            value={row.price}
                                            onChange={(e) => handleInputChange(index, 'price', e.target.value)}
                                            style={{ width: '100px' }}
                                        />
                                    </td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                                        <select
                                            value={row.currency}
                                            onChange={(e) => handleInputChange(index, 'currency', e.target.value)}
                                        >
                                            <option value=''>Select Currency</option>
                                            {currencyList.map((currency: any, idx: number) => (
                                                <option key={idx} value={currency.value}>
                                                    {currency.label}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={5}
                                    style={{ textAlign: 'center', border: '1px solid #ccc', padding: '8px' }}
                                >
                                    No Data Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div style={{ marginTop: '20px' }}>
                    {/* <button
                        type='submit'
                        disabled={formik.isSubmitting}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#1e88e5',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        {formik.isSubmitting ? 'Saving...' : 'Save changes'}
                    </button> */}

                    <button
                        type='button'
                        onClick={async (e) => {
                            console.log("Direct submit call");
                            e.preventDefault();

                            const values = formik.values;
                            const setSubmitting = formik.setSubmitting;

                            console.log("Form submission started");
                            console.log("Form values:", values);

                            // Check if priceData is empty
                            if (!values.priceData || values.priceData.length === 0) {
                                console.error("No price data to submit");
                                errorToast("No price data to submit");
                                setSubmitting(false);
                                return;
                            }

                            // Get token from local storage
                            const token = getAuthToken();
                            if (!token) {
                                console.error("Authentication token not found");
                                errorToast("Authentication token not found");
                                setSubmitting(false);
                                return;
                            }

                            setSubmitting(true);
                            try {
                                console.log("Preparing data for API call");

                                // Use all items in the payload
                                const updatedPriceData = values.priceData.map((item) => ({
                                    ...item,
                                    structureId: item.structureId || structureId || '',
                                    structureName: item.structureName
                                }));

                                console.log("API payload:", updatedPriceData);

                                // Direct fetch to the specified API endpoint with auth token
                                console.log("Making API call with authentication...");
                                const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}bulkPrice/update`, {
                                    method: 'PUT',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${token}`,
                                    },
                                    body: JSON.stringify(updatedPriceData),
                                });

                                console.log("API response status:", response.status);

                                if (!response.ok) {
                                    const errorText = await response.text();
                                    console.error("Error response:", errorText);
                                    throw new Error(`API error: ${response.status} - ${errorText}`);
                                }

                                const responseData = await response.json();
                                console.log("API response data:", responseData);

                                successToast('Updated Successfully');
                                console.log("Attempting to close modal...");
                                if (onClose) onClose();
                            } catch (ex: any) {
                                console.error("API call error:", ex);
                                errorToast(ex.message || 'Something Went Wrong');
                            } finally {
                                setSubmitting(false);
                                console.log("Form submission completed");
                            }
                        }}
                        disabled={formik.isSubmitting}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#1e88e5',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        {formik.isSubmitting ? 'Saving...' : 'Save changes'}
                    </button>
                    <button
                        type='button'
                        onClick={() => cancel()}
                        style={{
                            marginLeft: '10px',
                            padding: '8px 16px',
                            backgroundColor: '#e0e0e0',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PriceTemplateEditForm;